module.exports = __webpack_public_path__ + "02_very_short_gold.bc3aa580.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer5/02_very_short_gold.png
// module id = 3DVN
// module chunks = 0